import _ from 'lodash';
import { determineErrorFromResponse } from 'helpers/ContentHelper';
import {
  FETCH_NEXT_PAGE,
  TOGGLE_FETCHING,
  RESET_PAGINATION,
  INITIAL_STATE,
  setNextPage,
  setFetching,
  setResetPagination,
  fetchReducer,
} from 'helpers/PaginationHelper';
import { FETCH_SHOWS, RESET_STORE_SHOWS, SET_SUGGESTED_TAB } from './ShowsActions';

export default function(state, action) {
  const seo = _.get(action, 'payload.data.SEO', null);
  let newState = {
    ...INITIAL_STATE,
    ...state,
  };
  switch (action.type) {
    case FETCH_SHOWS: {
      const errors = determineErrorFromResponse(action);
      newState = {
        ...newState,
        errors,
        seo,
      };
      return fetchReducer({ action, state: newState });
    }
    case RESET_STORE_SHOWS: {
      return { ...setResetPagination({ state: newState }) };
    }
    case FETCH_NEXT_PAGE: {
      return setNextPage(action, newState);
    }
    case TOGGLE_FETCHING: {
      return setFetching(action, newState);
    }
    case RESET_PAGINATION: {
      return setResetPagination({ state: newState });
    }
    case SET_SUGGESTED_TAB: {
      const suggestedNetwork = _.get(action, 'payload.suggestedNetwork');
      const suggestedFilter = _.get(action, 'payload.suggestedFilter');
      return {
        ...newState,
        suggestedNetwork,
        suggestedFilter,
      };
    }
    default:
      return newState;
  }
}
